var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32178 5.89307H6.50831V15.3853H5.32178V5.89307Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69482 5.89307H8.88135V15.3853H7.69482V5.89307Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0679 5.89307H11.2544V15.3853H10.0679V5.89307Z",
    fill: "#ADADAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.575195 2.33356H16.0001V3.52009H0.575195V2.33356Z",
    fill: "#ADADAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2139 2.92677H10.1065V1.74024C10.1065 1.38428 9.8296 1.10743 9.47365 1.10743H7.10059C6.74463 1.10743 6.46777 1.38428 6.46777 1.74024V2.92677H5.36035V1.74024C5.36035 0.791016 6.15137 0 7.10059 0H9.47365C10.4229 0 11.2139 0.791016 11.2139 1.74024V2.92677Z",
    fill: "#ADADAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8467 18.9449H4.72755C3.77833 18.9449 2.94776 18.1539 2.86866 17.2046L1.76123 2.96631L2.94776 2.88721L4.05519 17.1255C4.09474 17.4815 4.41114 17.7584 4.72755 17.7584H11.8467C12.2027 17.7584 12.5191 17.4419 12.5191 17.1255L13.6265 2.88721L14.813 2.96631L13.7056 17.2046C13.6265 18.1934 12.7959 18.9449 11.8467 18.9449Z",
    fill: "#ADADAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e85addbb9a61b004ac6e6ac7f527ae93.svg";
export { ForwardRef as ReactComponent };